<script setup lang="ts">
import { Link } from '@inertiajs/vue3'

import { pageTitle } from '@consumer/logic/v2/header'
import { useIsPdfCapture } from '@consumer/composables/pdfCapture'

import CartMenu from './Header/CartMenu.vue'
import FavoritesMenu from './Header/FavoritesMenu.vue'
import GiftlyLogo from './Header/GiftlyLogo.vue'
import MainContainer from './Header/MainContainer.vue'
import UserMenu from './Header/UserMenu.vue'
import GiftlyLogoWhite from './Header/GiftlyLogoWhite.vue'

defineEmits(['close'])

const isPdfCapture = useIsPdfCapture()
</script>

<script lang="ts">
export const transparentHeader = ref(false)
</script>

<template>
  <div class="w-full z-navbar bg-white transition-all" :class="{ 'bg-transparent fixed': transparentHeader }">
    <V2Container class="!p-0 w-full">
      <MainContainer>
        <div class="w-full flex items-center justify-between h-15">
          <div
            class="flex items-center gap-4 transition-all"
          >
            <GiftlyLogoWhite v-if="transparentHeader"/>
            <GiftlyLogo v-else/>
            <Link :href="pageTitle.href ?? '/'" class="no-underline group">
              <h1 class="text-sm font-medium text-v2-tertiary hover:text-navy">
                {{ pageTitle.text }}
              </h1>
            </Link>
          </div>

          <Transition name="fade-in-out" appear>
            <div v-if="!transparentHeader && !isPdfCapture" class="flex items-center gap-2 lg:gap-4">
              <FavoritesMenu/>
              <CartMenu/>
              <UserMenu/>
            </div>
          </Transition>
        </div>
      </MainContainer>
    </V2Container>
  </div>
</template>
